import React, { Suspense } from 'react'
import type { KambiSportName } from '@mobi/api-types/kambi/sports'
import type { DefaultIconType, SportIconSize } from '../../types'
import { DefaultIcon } from './Components/Common/DefaultIcon'
import { mappedSportsWithNationalFlags } from './Components/index'

export const TeamIcon: React.FC<{
  size: SportIconSize
  participantId: number | null | undefined
  sportName: KambiSportName | undefined
  defaultIconType?: DefaultIconType
}> = ({ participantId, size, sportName, defaultIconType }) => {
  const MappedIcon = participantId && sportName && mappedSportsWithNationalFlags[sportName]

  if (MappedIcon) {
    return (
      <Suspense fallback={null}>
        <MappedIcon
          size={size}
          participantId={participantId}
          sportName={sportName}
          defaultIconType={defaultIconType ?? null}
        />
      </Suspense>
    )
  }

  return (
    <DefaultIcon
      sportName={sportName}
      defaultIconType={defaultIconType ?? (sportName ? 'sport-icon' : null)}
      size={size}
    />
  )
}
